export const isOrderSeat = (seat) => 'seatLabel' in seat;
//# sourceMappingURL=type-guards.js.map